export const ListQueryKey = 'exclusiveCards';
export const DetailQueryKey = 'exclusiveCard';
export const Urls = {
  selectUrl: '/exclusiveCard/list',
  updateUrl: '/exclusiveCard/update',
  deleteUrl: '/exclusiveCard/delete',
  createUrl: '/exclusiveCard/create',
  detailUrl: '/exclusiveCard/detail'
};